import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, incentivePaymentData, detailsReport = false, isBillCollection = false) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(incentivePaymentData,detailsReport, isBillCollection),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: getTitle(detailsReport, isBillCollection),
            }
        }

        pushIntoTable(doc, incentivePaymentData, detailsReport, isBillCollection)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    function getTitle(detailsReport, isBillCollection) {
        if (detailsReport && isBillCollection) return "Bill Collection Detailed Statement";
        if (detailsReport && !isBillCollection) return "Incentive Detailed Statement";
        if (!detailsReport && isBillCollection) return "Bill Collection Summary Statement";
        return "Incentive Summary Statement";
    }

    const getContent = (incentivePaymentData, detailsReport, isBillCollection) => {
        return [
            {
                text: getTitle(detailsReport, isBillCollection),
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                margin: [0, 20, 0, 0],
                alignment: 'justify',
                columns: [
                    {
                        width: '50%',
                        stack: [
                            {
                                text: `Name: ${incentivePaymentData.data.details.referrer_name}`,
                                alignment: 'left',
                                width: '50%'
                            },
                            {
                                text: `Payment Date: ${incentivePaymentData.data.details.payment_date}`,
                                alignment: 'left',
                                width: '50%'
                            },
                        ]
                    },

                ]
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: customWidth(isBillCollection)
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },

            formatSignatureData()
        ]
    }

    const customWidth = ( isBillCollection) => {
        if (isBillCollection){
            return [ '17%', '18%','20%', '15%', '15%', '15%'];
        }
        return [ '12%', '13%','15%', '10%', '10%', '10%', '10%', '10%', '10%' ]
    }

    const pushIntoTable = (doc, incentivePaymentData, detailsReport, isBillCollection) => {
        const tableItems = incentivePaymentData.data.data;
        const tableHeader = getTableHeader(isBillCollection);
        doc.content[2].table.body.push(tableHeader);

        tableItems.forEach((item, i) => {
            const rowData = getRowData(item, i, isBillCollection);
            doc.content[2].table.body.push(rowData);

            if (!detailsReport){
                return
            }

            const detailsRow = getRowDetails(item.item_details || '', isBillCollection);
            doc.content[2].table.body.push(detailsRow);
        });

        const getLastRow = getTotal(incentivePaymentData.data.details, isBillCollection)
        doc.content[2].table.body.push(getLastRow);
    }

    const getTableHeader = (isBillCollection) => {
        const tableHeader = [
            {text: 'Invoice Date'},
            {text: 'Invoice No'},
            {text: 'Patient Name (ID)'},
            {text: 'Total Bill', alignment: 'right'},
            {text: 'Total Discount', alignment: 'right'},
            {text: 'Net Bill', alignment: 'right'},
        ]

        if (isBillCollection){
            return tableHeader
        }

        tableHeader.push(
            {text: 'Total Incentive', alignment: 'right'},
            {text: 'Referrer Discount', alignment: 'right'},
            {text: 'Net Incentive', alignment: 'right'},
        )

        return tableHeader
    }

    const getRowData = (item, i, isBillCollection) => {

        if (isBillCollection){
            return [
                {text: item.sale_master_date},
                {text: item.bill_number},
                {text: item.contact_profile_name + '(' + item.cp_serial_no + ')' },
                {text: commaFormat(item.total_invoice), alignment: 'right'},
                {text: commaFormat(item.total_discount), alignment: 'right'},
                {text: commaFormat(item.net_bill), alignment: 'right'},
            ]
        }

        const tableRow = [
            {text: item.sale_master.date},
            {text: item.sale_master.bill_number},
            {text: item.sale_master.patient_name + '(' + item.sale_master.patient_serial_no + ')' },
            {text: commaFormat(item.total_invoice), alignment: 'right'},
            {text: commaFormat(item.total_discount), alignment: 'right'},
            {text: commaFormat(item.net_bill), alignment: 'right'},
            {text: commaFormat(item.total_incentive), alignment: 'right'},
            {text: commaFormat(item.referrer_discount), alignment: 'right'},
            {text: commaFormat(item.net_incentive), alignment: 'right'},
     ]

        return tableRow
    }

    const formatSignatureData = () => {

        let signatures = [ 'Prepared By', 'Reviewed By', 'Approved By' ];

        return {
            alignment: 'justify',
            absolutePosition: { x: 60, y: 740 },
            columns: signatures.map(getSingleSignature)
        }
    }

    const getSingleSignature = (title) => {
        return {
            width: '43%',
            stack: [
                {
                    canvas: [
                        {
                            type: 'line',
                            x1: 0,
                            y1: 0,
                            x2: 58,
                            y2: 0,
                            lineWidth: 1
                        }
                    ]
                },
                {
                    margin: [ 0, 5, 0, 0 ],
                    text: `${title} `,
                    color: 'black',
                    bold: true,
                    alignment: 'left',
                }
            ]
        }
    }

    const getRowDetails = (itemDetails, isBillCollection) => {
        return [
            {
                text: itemDetails,
                colSpan: isBillCollection ? 6 : 9
            },
            isBillCollection ? [{}, {}, {}, {}, {}] : [{}, {}, {}, {}, {}, {}, {}, {}]
        ];
    };

    const getTotal = (totalValue, isBillCollection) => {
        let colSpanValue = 3;
        let emptyCells = 2;

        const lastRow = [
            {
                text: 'Total',
                alignment: 'right',
                colSpan: colSpanValue
            },

            ...Array(emptyCells).fill({}),

            {
                text: totalValue.total_invoice,
                alignment: 'right'
            },

            {
                text: totalValue.total_discount,
                alignment: 'right'
            },

            {
                text: totalValue.net_bill,
                alignment: 'right'
            },
        ]

        if (isBillCollection){
            return lastRow;
        }

        lastRow.push(
            {
                text: totalValue.total_incentive,
                alignment: 'right'
            },

            {
                text: totalValue.referrer_discount,
                alignment: 'right'
            },

            {
                text: totalValue.net_incentive,
                alignment: 'right'
            }
         )

        return lastRow
    }

    return {
        exportToPDF
    }

}

export default pdfPrinter;